import axios from 'axios';
import {
  REFRESH_TOKEN,
  // SIGN_OUT_BEGIN,
  SIGN_OUT_SUCCESS,
  SIGN_OUT_FAILURE,
  // FETCH_ME,
  NOT_LOGGED_IN,
  FETCH_SECURITY_SUCCESS,
  FETCH_SECURITY_FAIL,
  FETCH_ME_SUCCESS,
  // FETCH_ME_FAIL,
  GENERIC_ERROR,
  DISABLE_OTP_SUCCESS,
  DISABLE_OTP_FAIL,
  ENABLE_OTP_SUCCESS,
  ENABLE_OTP_FAIL,
  ACTIVATE_OTP_SUCCESS,
  ACTIVATE_OTP_FAIL,
  VALIDATE_PASSWORD_SUCCESS,
  VALIDATE_PASSWORD_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAIL,
  UPDATE_PWD_SUCCESS,
  UPDATE_PWD_FAIL,
  CREATE_DOCS_SUCCESS,
  CREATE_DOCS_FAIL,
  CREATE_IDENTITY_SUCCESS,
  CREATE_IDENTITY_FAIL,
  FETCH_IDENTITY_SUCCESS,
  FETCH_IDENTITY_FAIL,
  CREATE_TOKEN_SUCCESS,
  CREATE_TOKEN_FAIL,
  DELETE_TOKEN_SUCCESS,
  DELETE_TOKEN_FAIL,
  FETCH_TOKENS_SUCCESS,
  FETCH_TOKENS_FAIL,
  VALIDATE_IP_SUCCESS,
  VALIDATE_IP_FAIL,
  TOGGLE_TEMP_ANON_SUCCESS,
  TOGGLE_TEMP_ANON_FAIL,
  CREATE_MASTER_PASSWORD_SUCCESS,
  CREATE_MASTER_PASSWORD_FAIL,
  RESET_MASTER_PASSWORD_SUCCESS,
  RESET_MASTER_PASSWORD_FAIL,
  ACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS,
  ACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL,
  DEACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS,
  DEACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL,
  FETCH_LOGIN_HISTORY_SUCCESS,
  FETCH_LOGIN_HISTORY_FAIL,
  REQUEST_EMAIL_CHANGE_SUCCESS,
  REQUEST_EMAIL_CHANGE_FAIL,
  UPDATE_USER_TERMS_VERSION_SUCCESS,
  UPDATE_USER_TERMS_VERSION_FAIL,
  FETCH_LOGIN_SESSIONS_SUCCESS,
  FETCH_LOGIN_SESSIONS_FAIL,
  EXPIRE_LOGIN_SESSION_SUCCESS,
  EXPIRE_LOGIN_SESSION_FAIL,
  FETCH_SIWE_NONCE_SUCCESS,
  FETCH_SIWE_NONCE_FAIL,
  TOGGLE_SIWE_SUCCESS,
  TOGGLE_SIWE_FAIL,
} from './types';
import TokenService from "../services/tokenService";

export const createIdentity = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user/identity';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: CREATE_IDENTITY_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: CREATE_IDENTITY_FAIL, errors: error });
    }

    return dispatch({ type: CREATE_IDENTITY_FAIL });
  }
};

export const fetchIdentity = (state) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user/identity';
  try {
    const response = await axios.get(url);
    return dispatch({ type: FETCH_IDENTITY_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_IDENTITY_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_IDENTITY_FAIL });
  }
};

export const updatePassword = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user/security';
  try {
    const response = await axios.patch(url, data);
    return dispatch({ type: UPDATE_PWD_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: UPDATE_PWD_FAIL, errors: error });
    }

    return dispatch({ type: UPDATE_PWD_FAIL });
  }
};

export const validatePwd = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user/security';
  try {
    const response = await axios.patch(url, data);
    return dispatch({ type: VALIDATE_PASSWORD_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: VALIDATE_PASSWORD_FAIL, errors: error });
    }

    return dispatch({ type: VALIDATE_PASSWORD_FAIL });
  }
};

export const disableOTP = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user/security';
  try {
    const response = await axios.patch(url, data);
    return dispatch({ type: DISABLE_OTP_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: DISABLE_OTP_FAIL, errors: error });
    }

    return dispatch({ type: DISABLE_OTP_FAIL });
  }
};

export const enableOTP = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user/security';
  try {
    const response = await axios.patch(url, data);
    return dispatch({ type: ENABLE_OTP_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: ENABLE_OTP_FAIL, errors: error });
    }

    return dispatch({ type: ENABLE_OTP_FAIL });
  }
};

export const activateOTP = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user/security';
  try {
    const response = await axios.patch(url, data);
    return dispatch({ type: ACTIVATE_OTP_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: ACTIVATE_OTP_FAIL, errors: error });
    }

    return dispatch({ type: ACTIVATE_OTP_FAIL });
  }
};

export const toggleSIWE = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user/security';
  try {
    const response = await axios.patch(url, data);
    return dispatch({ type: TOGGLE_SIWE_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: TOGGLE_SIWE_FAIL, errors: error });
    }

    return dispatch({ type: TOGGLE_SIWE_FAIL });
  }
};

export const updateUser = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user';
  try {
    const response = await axios.patch(url, data);
    return dispatch({ type: UPDATE_USER_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: UPDATE_USER_FAIL, errors: error });
    }

    return dispatch({ type: UPDATE_USER_FAIL });
  }
};

export const fetchUser = (state) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user';
  try {
    const response = await axios.get(url);
    return dispatch({ type: FETCH_USER_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      console.log(error);
      // location.push('/login')
      return dispatch({ type: FETCH_USER_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_USER_FAIL });
  }
};

export const fetchMe = (state) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/me';
  try {
    const response = await axios.get(url);
    return dispatch({ type: FETCH_ME_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      console.log(error);
      // location.push('/login')
      return dispatch({ type: NOT_LOGGED_IN, errors: error });
    }

    return dispatch({ type: GENERIC_ERROR });
  }
};

export const fetchSecurity = (state) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user/security';
  try {
    const response = await axios.get(url);
    return dispatch({ type: FETCH_SECURITY_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      console.log(error);
      // location.push('/login')
      return dispatch({ type: FETCH_SECURITY_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_SECURITY_FAIL });
  }
};

export const fetchNonceForSIWE = (state) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user/siwe/nonce';
  try {
    const response = await axios.get(url);
    return dispatch({ type: FETCH_SIWE_NONCE_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      console.log(error);
      // location.push('/login')
      return dispatch({ type: FETCH_SIWE_NONCE_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_SIWE_NONCE_FAIL });
  }
};

export const signOut = (cookies,history) => dispatch => {
  return axios.post(process.env.REACT_APP_API_URL + '/auth/logout').then(res => {
    let key = '_vto';
    let keyOA = '_vtoa';
    cookies.remove(key, { hostname: process.env.REACT_APP_HOSTNAME, path: '/' });
    cookies.remove(keyOA, { hostname: process.env.REACT_APP_HOSTNAME, path: '/' });
    TokenService.removeUser();
    return dispatch({type: SIGN_OUT_SUCCESS});
  }).catch((err) => {
    return dispatch({ type: SIGN_OUT_FAILURE, payload: err });
  });
};

export const createToken = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/tokens';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: CREATE_TOKEN_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: CREATE_TOKEN_FAIL, errors: error });
    }

    return dispatch({ type: CREATE_TOKEN_FAIL });
  }
};

export const fetchTokens = (state) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/tokens';
  try {
    const response = await axios.get(url);
    return dispatch({ type: FETCH_TOKENS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      console.log(error);
      // location.push('/login')
      return dispatch({ type: FETCH_TOKENS_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_TOKENS_FAIL });
  }
};

export const deleteToken = (id) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/tokens/' + id;
  try {
    const response = await axios.delete(url);
    return dispatch({ type: DELETE_TOKEN_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: DELETE_TOKEN_FAIL, errors: error });
    }
    return dispatch({ type: DELETE_TOKEN_FAIL });
  }
};

export const validateIP = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/public/disableIpBlock';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: VALIDATE_IP_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: VALIDATE_IP_FAIL, errors: error });
    }

    return dispatch({ type: VALIDATE_IP_FAIL });
  }
};

export const toggleTempAnon = (data) => async (dispatch) => {
  if (data) {
    localStorage.setItem('vtanon', 'vt anon enabled');
  } else {
    localStorage.removeItem('vtanon');
  }
  try {
    return dispatch({ type: TOGGLE_TEMP_ANON_SUCCESS, payload: data });
  } catch (error) {
    if (error) {
      return dispatch({ type: TOGGLE_TEMP_ANON_FAIL, errors: error });
    }
    return dispatch({ type: TOGGLE_TEMP_ANON_FAIL });
  }
};

export const createMasterPassword = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/security/masterPassword';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: CREATE_MASTER_PASSWORD_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: CREATE_MASTER_PASSWORD_FAIL, errors: error });
    }
    return dispatch({ type: CREATE_MASTER_PASSWORD_FAIL });
  }
};

export const resetMasterPassword = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/security/resetMasterPassword';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: RESET_MASTER_PASSWORD_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: RESET_MASTER_PASSWORD_FAIL, errors: error });
    }
    return dispatch({ type: RESET_MASTER_PASSWORD_FAIL });
  }
};

export const activateGlobalSettingsLock = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/security/globalSettingsLock';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: ACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: ACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL, errors: error });
    }
    return dispatch({ type: ACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL });
  }
};

export const deactivateGlobalSettingsLock = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/security/globalSettingsLock';
  try {
    const response = await axios.delete(url, { params });
    return dispatch({ type: DEACTIVATE_GLOBAL_SETTINGS_LOCK_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: DEACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL, errors: error });
    }
    return dispatch({ type: DEACTIVATE_GLOBAL_SETTINGS_LOCK_FAIL });
  }
};

export const fetchLoginHistory = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/history/logins';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_LOGIN_HISTORY_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_LOGIN_HISTORY_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_LOGIN_HISTORY_FAIL });
  }
};

export const requestEmailChange = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user/changeEmail';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: REQUEST_EMAIL_CHANGE_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: REQUEST_EMAIL_CHANGE_FAIL, errors: error });
    }
    return dispatch({ type: REQUEST_EMAIL_CHANGE_FAIL });
  }
};

export const refreshToken = (data) => (dispatch) => {
  dispatch({ type: REFRESH_TOKEN, payload: data });
}

export const updateUserTermsVersion = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/user/terms';
  try {
    const response = await axios.patch(url, data);
    return dispatch({ type: UPDATE_USER_TERMS_VERSION_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: UPDATE_USER_TERMS_VERSION_FAIL, errors: error });
    }
    return dispatch({ type: UPDATE_USER_TERMS_VERSION_FAIL });
  }
};

export const fetchLoginSessions = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/security/activeSessions';
  try {
    const response = await axios.get(url, data);
    return dispatch({ type: FETCH_LOGIN_SESSIONS_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_LOGIN_SESSIONS_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_LOGIN_SESSIONS_FAIL });
  }
};

export const expireLoginSession = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/security/expireSession';
  try {
    const response = await axios.delete(url, data);
    return dispatch({ type: EXPIRE_LOGIN_SESSION_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: EXPIRE_LOGIN_SESSION_FAIL, errors: error });
    }

    return dispatch({ type: EXPIRE_LOGIN_SESSION_FAIL });
  }
};
